import _ from 'underscore';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { Target } from '@bingads-webui-react/dimensions-target';
import { I18nContext } from '@bingads-webui-react/i18n-context';

import { Genders } from '../consts';

const sortGenders = genders => _.sortBy(genders, gender => Genders[gender]);

export const formatGender = (gender, i18n) => (Genders[gender] ? i18n.getString(Genders[gender]) : gender);

export const formatGenders = (genders, i18n) => {
  const gendersListString = _.size(genders) === _.size(Genders)
    ? i18n.getString(_TL_('All genders'))
    : _.chain(sortGenders(genders))
      .map(gender => formatGender(gender, i18n))
      .join(i18n.getString(_TL_(', ')))
      .value();

  return i18n.getString(_TL_('Targeting: {{targets}}'), { targets: gendersListString });
};

export const TargetingGender = ({ genders }) => {
  const i18n = useContext(I18nContext);

  return (
    <div className="gender-targeting">
      <Target
        i18n={i18n}
        ariaLabel={i18n.getString(_TL_('Gender groups'))}
        description={i18n.getString(_TL_('Show your ads to people in these gender groups (select all that apply)'))}
        formatter={formatGender}
        availableDimensions={Genders}
        dimensions={genders}
        validationProps={{ field: 'genders' }}
        hideDeselectAll
      />
    </div>
  );
};

TargetingGender.propTypes = {
  genders: PropTypes.arrayOf(PropTypes.string).isRequired,
};
